import { render, staticRenderFns } from "./result-hover-opportunities.vue?vue&type=template&id=f1dc2d6c&scoped=true&"
import script from "./result-hover-opportunities.vue?vue&type=script&lang=js&"
export * from "./result-hover-opportunities.vue?vue&type=script&lang=js&"
import style0 from "./result-hover-opportunities.vue?vue&type=style&index=0&id=f1dc2d6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1dc2d6c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1dc2d6c')) {
      api.createRecord('f1dc2d6c', component.options)
    } else {
      api.reload('f1dc2d6c', component.options)
    }
    module.hot.accept("./result-hover-opportunities.vue?vue&type=template&id=f1dc2d6c&scoped=true&", function () {
      api.rerender('f1dc2d6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade-dsm-application/result-components/helpers/result-hover-opportunities.vue"
export default component.exports